<template>
  <div>
    <base-header class="pb-6 content__title content__title--calendar">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <!-- <h6 class="h2 text-muted d-inline-block mb-0">{{ $route.name }}</h6> -->
          <router-link :to="'/customerProfile' + '?page=' + listing_current_page" class="text-primary">
            <b-icon icon="chevron-left"></b-icon>
            Customer Profile
          </router-link>
        </div>
        <div class="col-lg-6 mt-3 mt-lg-0 text-lg-right">
          <a
            href="#"
            @click.prevent="prev"
            class="fullcalendar-btn-prev btn btn-sm btn-default"
          >
            <i class="fas fa-angle-left"></i>
          </a>
          <a
            href="#"
            @click.prevent="next"
            class="fullcalendar-btn-next btn btn-sm btn-default"
          >
            <i class="fas fa-angle-right"></i>
          </a>
          <base-button
            class="btn btn-sm btn-default"
            @click="changeView('dayGridMonth')"
          >
            Month
          </base-button>
          <base-button
            class="btn btn-sm btn-default"
            @click="changeView('dayGridWeek')"
          >
            Week
          </base-button>
          <base-button
            class="btn btn-sm btn-default"
            @click="changeView('timeGridDay')"
          >
            Day
          </base-button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <!-- Fullcalendar -->
          <div class="card card-calendar">
            <!-- Card header -->
            <div class="card-header">
              <!-- Title -->
              <h5 class="h3 mb-0">Calendar</h5>
            </div>
            <!-- Card body -->
            <div class="card-body p-0 card-calendar-body">
              <div id="fullCalendar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <modal :show.sync="showAddModal" modal-classes="modal-secondary">
        <form class="new-event--form" @submit.prevent="saveEvent">
          <base-input
            name="title"
            label="Event title"
            placeholder="Event Title"
            v-model="model.title"
            input-classes="form-control-alternative new-event--title"
          >
          </base-input>
          <div class="form-group">
            <label class="form-control-label d-block mb-3">Status color</label>
            <div class="btn-group btn-group-toggle btn-group-colors event-tag">
              <label
                v-for="color in eventColors"
                :key="color"
                class="btn"
                :class="[color, { 'active focused': model.className === color }]"
              >
                <input
                  v-model="model.className"
                  type="radio"
                  name="event-tag"
                  :value="color"
                  autocomplete="off"
                />
              </label>
            </div>
          </div>
          <input type="hidden" class="new-event--start" />
          <input type="hidden" class="new-event--end" />
        </form>
  
        <template v-slot:footer>
          <button
            type="submit"
            class="btn btn-primary new-event--add"
            @click="saveEvent"
          >
            Add event
          </button>
          <button
            type="button"
            class="btn btn-link ml-auto"
            @click="showAddModal = false"
          >
            Close
          </button>
        </template>
      </modal> -->

    <modal :show.sync="showEditModal" modal-classes="modal-secondary">
      <h3>{{ model.title }}</h3>
      <p><strong>Agent Assigned:</strong> {{ model.agent_name }}</p>
      <p><strong>Contact No:</strong> {{ model.contact_no }}</p>
      <p><strong>E-mail:</strong> {{ model.email }}</p>
      <p><strong>Appointment At:</strong> {{ model.start }}</p>
      <p><strong>Sub Status:</strong> {{ model.sub_status }}</p>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/Modal";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridDay from "@fullcalendar/timegrid";
// import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import {
  notifyFunctionMixin,
  axios,
  services,
  getHeader,
  debounce,
} from "@/assets/js/httpImports.js";

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();
var calendar;
export default {
  name: "calendar",
  components: {
    // RouteBreadCrumb,
    Modal,
  },
  data() {
    return {
      event: [],
      customersData: [],
      listing_current_page: 1, 
      // events: [
      //   {
      //     title: "All Day Event",
      //     start: new Date(y, m, 1),
      //     className: "event-default",
      //   },
      //   {
      //     id: 999,
      //     title: "Repeating Event",
      //     start: new Date(y, m, d - 4, 6, 0),
      //     allDay: false,
      //     className: "event-green",
      //   },
      //   {
      //     id: 999,
      //     title: "Repeating Event",
      //     start: new Date(y, m, d + 3, 6, 0),
      //     allDay: false,
      //     className: "event-orange",
      //   },
      //   {
      //     title: "Meeting",
      //     start: new Date(y, m, d - 1, 10, 30),
      //     allDay: false,
      //     className: "event-green",
      //   },
      //   {
      //     title: "Lunch",
      //     start: new Date(y, m, d + 7, 12, 0),
      //     end: new Date(y, m, d + 7, 14, 0),
      //     allDay: false,
      //     className: "event-red",
      //   },
      //   {
      //     title: "Md-pro Launch",
      //     start: new Date(y, m, d - 2, 12, 0),
      //     allDay: true,
      //     className: "event-azure",
      //   },
      //   {
      //     title: "Birthday Party",
      //     start: new Date(y, m, d + 1, 19, 0),
      //     end: new Date(y, m, d + 1, 22, 30),
      //     allDay: false,
      //     className: "event-azure",
      //   },
      //   {
      //     title: "Click for Creative Tim",
      //     start: new Date(y, m, 21),
      //     end: new Date(y, m, 22),
      //     url: "http://www.creative-tim.com/",
      //     className: "event-orange",
      //   },
      //   {
      //     title: "Click for Google",
      //     start: new Date(y, m, 21),
      //     end: new Date(y, m, 22),
      //     url: "http://www.creative-tim.com/",
      //     className: "event-orange",
      //   },
      // ],
      model: {
        title: "New event",
        className: "bg-default",
        description:
          "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        start: "",
        end: "",
      },
      showAddModal: false,
      showEditModal: false,
      eventColors: [
        "bg-info",
        "bg-orange",
        "bg-red",
        "bg-green",
        "bg-default",
        "bg-blue",
        "bg-purple",
        "bg-yellow",
      ],
    };
  },
  methods: {
    initCalendar() {
      var calendarEl = document.getElementById("fullCalendar");

      calendar = new Calendar(calendarEl, {
        plugins: [dayGridPlugin, timeGridDay, interactionPlugin],
        selectable: true,
        headerToolbar: false,
        select: () => {
          this.showAddModal = true;
          this.model.start = new Date(y, m, 21);
          this.model.end = new Date(y, m, 21);
        },
        eventClick: (info) => {
          const custId = info.event.id;
          this.getSingleCustomer(custId);

          // this.model = {
          //   title: event.title,
          //   className: event.classNames ? event.classNames.join(" ") : "",
          //   start: event.start,
          //   end: event.end,
          //   description:
          //     "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
          // };
          this.showEditModal = true;
        },
        events: this.events,
      });
      calendar.render();
    },
    changeView(newView) {
      calendar.changeView(newView);
      calendar.view.title;
    },
    next() {
      calendar.next();
    },
    prev() {
      calendar.prev();
    },
    saveEvent() {
      if (this.model.title) {
        let event = {
          ...this.model,
          allDay: true,
        };
        this.events.push(JSON.parse(JSON.stringify(event)));
        this.model = {
          title: "",
          eventColor: "bg-danger",
          start: "",
          end: "",
        };
      }
      this.showAddModal = false;
    },
    editEvent() {
      let index = this.events.findIndex((e) => e.title === this.model.title);
      if (index !== -1) {
        this.events.splice(index, 1, this.model);
      }
      this.showEditModal = false;
    },
    deleteEvent() {
      let index = this.events.findIndex((e) => e.title === this.model.title);
      if (index !== -1) {
        this.events.splice(index, 1);
      }
      this.showEditModal = false;
    },
    async getSingleCustomer(customer_id) {
      try {
        const response = await axios.get(
          services.customer + "customers/" + customer_id + "?full=yes",
          { headers: getHeader() }
        );
        const customerData = response.data.data;
        // console.log(customerData);
        (this.model = {
          title: customerData.name,
          agent_name: customerData.se.name,
          className: "bg-green",
          start: customerData.appointment_at,
          end: customerData.appointment_at,
          description: customerData.name,
          id: customerData.customer_id,
          contact_no:
            customerData.contact_no !== null ? customerData.contact_no : "N/A",
          email: customerData.email !== null ? customerData.email : "N/A",
          // main_status: customerData.status.main !== null ? customerData.status.main.status : "N/A",
          sub_status:
            customerData.status.sub !== null
              ? customerData.status.sub.status
              : "N/A",
        }),
          // console.log(this.model);
          (this.showEditModal = true);
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    },
  },
  mounted() {
    axios
      .get(services.customer + "customer-appt", { headers: getHeader() })
      .then((res) => {
        const customersData = res.data.data;

        if (typeof customersData === "object" && customersData !== null) {
          const customersArray = Object.values(customersData);
          this.events = customersArray.map((cust) => {

            const agentName = cust.assignToDetails ? cust.assignToDetails.se_name : '';
            const agentInitials = _gHlp.formatInitials(agentName)

            const titleWithInitials = `(${agentInitials}) ${cust.name} `;

            return {
              title: titleWithInitials,
              start: cust.appointment_at,
              end: cust.appointment_at,
              className: "bg-green",
              description: cust.name,
              id: cust.customer_id,
            };
          });
          this.initCalendar();
        } else {
          console.error("leadsData is not an object or is null:", leadsData);
          this.events = [];
        }
      })
      .catch((e) => {
        if (typeof this.errorFunction === "function") {
          this.errorFunction(e);
        } else {
          console.error(
            "An error occurred, but errorFunction is not defined:",
            e
          );
        }
      });
  },
};
</script>
<style lang="scss">
@import "~@/assets/sass/core/vendors/fullcalendar";
</style>
